import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import WhatsInside from "./components/WhatsInside";
import About from "./components/About";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import BundleValue from "./components/BundleValue";
import Speaking from "./components/Speaking";
import CTAFooter from "./components/CTAFooter";
import { PaymentSuccess, PaymentCancel } from "./components/PaymentResult";
import AdminPage from "./components/AdminPage";
import LivestreamPage from "./components/LivestreamPage";

const Landing = () => (
  <div id="top" className="App">
    <Header />
    <main>
      <Hero />
      <Benefits />
      <WhatsInside />
      <BundleValue />
      <About />
      <Testimonials />
      <Speaking />
      <FAQ />
      <CTAFooter />
    </main>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/livestream/:token" element={<LivestreamPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
